import React, { useState } from 'react';
import { TaskItem } from '../components/TaskItem';
import { CashReconciliation } from '../components/CashReconciliation';
import { InventoryTransfer } from '../components/InventoryTransfer';
import { SecurityChecklist } from '../components/SecurityChecklist';
interface RunbookExecutionProps {
  type: string;
  onComplete: () => void;
}
export const RunbookExecution: React.FC<RunbookExecutionProps> = ({
  type,
  onComplete
}) => {
  const [activeTask, setActiveTask] = useState<string | null>(null);
  const [completedTasks, setCompletedTasks] = useState<string[]>([]);
  const [flaggedTasks, setFlaggedTasks] = useState<string[]>(['cash-reconciliation']);
  const tasks = [{
    id: 'cash-reconciliation',
    title: 'Cash Reconciliation',
    description: 'Count and verify all registers',
    assignee: 'Alex'
  }, {
    id: 'inventory-transfer',
    title: 'HVM Transfer',
    description: 'Secure high-value merchandise',
    assignee: 'Jamie'
  }, {
    id: 'security-checklist',
    title: 'Security Checklist',
    description: 'Complete all security checks',
    assignee: 'Alex'
  }];
  const completeTask = (taskId: string, hasIssue: boolean = false) => {
    if (hasIssue) {
      setFlaggedTasks(prev => [...prev, taskId]);
    } else {
      setCompletedTasks(prev => [...prev, taskId]);
    }
    setActiveTask(null);
  };
  const getTaskStatus = (taskId: string) => {
    if (completedTasks.includes(taskId)) return 'completed';
    if (flaggedTasks.includes(taskId)) return 'flagged';
    if (activeTask === taskId) return 'in-progress';
    return 'pending';
  };
  const renderTaskContent = () => {
    switch (activeTask) {
      case 'cash-reconciliation':
        return <CashReconciliation onComplete={hasIssue => completeTask('cash-reconciliation', hasIssue)} data-id="element-326" />;
      case 'inventory-transfer':
        return <InventoryTransfer onComplete={hasIssue => completeTask('inventory-transfer', hasIssue)} data-id="element-327" />;
      case 'security-checklist':
        return <SecurityChecklist onComplete={hasIssue => completeTask('security-checklist', hasIssue)} data-id="element-328" />;
      default:
        return null;
    }
  };
  const allTasksAddressed = tasks.every(task => completedTasks.includes(task.id) || flaggedTasks.includes(task.id));
  return <div className="p-4 space-y-6" data-id="element-329">
      {!activeTask ? <>
          <div className="mb-4" data-id="element-330">
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-331">
              End-of-Day Tasks
            </h2>
            <p className="text-sm text-gray-500" data-id="element-332">
              Complete all tasks to finalize closing
            </p>
          </div>
          <div className="space-y-3" data-id="element-333">
            {tasks.map(task => <TaskItem key={task.id} id={task.id} title={task.title} description={task.description} status={getTaskStatus(task.id)} assignee={task.assignee} onClick={() => setActiveTask(task.id)} data-id="element-334" />)}
          </div>
          {allTasksAddressed && <div className="mt-6" data-id="element-335">
              <button onClick={onComplete} className="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors" data-id="element-336">
                Complete & Submit for Review
              </button>
            </div>}
        </> : renderTaskContent()}
    </div>;
};